import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/cn";

export interface ProductStockProps {
  stock: number | undefined;
  /** A partir de cuántas unidades el número se pinta como aviso. */
  lowThreshold?: number;
}

/**
 * Las existencias.
 *
 * `undefined` NO es cero: significa que ese producto no lleva control de
 * inventario. Pintar "0" en su lugar diría "agotado" y haría que alguien
 * saliera a reponer algo que nunca se contó.
 */
export function ProductStock({ stock, lowThreshold = 5 }: ProductStockProps) {
  const { t } = useTranslation();

  if (stock === undefined) {
    return (
      <span className="text-ds-ink-3" title={t("Sin control de existencias")}>
        —
      </span>
    );
  }

  const isOut = stock === 0;
  const isLow = !isOut && stock <= lowThreshold;

  return (
    <span
      className={cn(
        "font-semibold tabular-nums",
        isOut && "text-ds-terracotta",
        isLow && "text-ds-amber-soft",
        !isOut && !isLow && "text-ds-ink",
      )}
      title={isOut ? t("Agotado") : isLow ? t("Quedan pocas") : undefined}
    >
      {stock}
    </span>
  );
}
